import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'

export const Subtitle = styled.p`
  b {
    color: ${Colors.Neutral100};
    ${FontWeights.DemiBold}
  }
`

export const Image = styled.img`
  width: 100%;
  height: 280px;
  object-fit: cover;
`
